module.exports = __webpack_public_path__ + "static/media/sheeba_D'Mello.932c2880.png";